import { JarvisAuthProvider } from '@jarvis/web-http';
import axios, { AxiosInstance } from 'axios';
import sendOpenTelemetryEvent from '../helpers/sendOpenTelemetryEvent';
import { Address } from '../types/address';
import environments from '../configs/environment.json';

class AddressClient {
  httpClient: AxiosInstance;
  mfeAuthProvider: JarvisAuthProvider;
  baseUrl: string;

  constructor(
    authProvider: JarvisAuthProvider,
    stack?: any // eslint-disable-line @typescript-eslint/no-explicit-any
  ) {
    this.httpClient = axios;
    this.mfeAuthProvider = authProvider;

    type EnvKey = keyof typeof environments;
    const envKeys = Object.keys(environments) as EnvKey[];
    const currentEnv = environments[envKeys[stack]];

    this.baseUrl =
      currentEnv?.variables?.BASE_URL_PROVIDER ||
      'https://pie-us1.api.ws-hp.com';
  }

  async getAddressById(shippingAddressId: string): Promise<Address> {
    try {
      if (!shippingAddressId) {
        throw new Error('Shipping address ID is required');
      }

      const stratusToken = await this.mfeAuthProvider.getAccessToken();
      const headers = {
        accept: 'application/json',
        authorization: `Bearer ${stratusToken}`
      };

      const response = await this.httpClient.get(
        `${this.baseUrl}/v1/addresssvc/addresses/${shippingAddressId}`,
        { headers }
      );

      return response.data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      sendOpenTelemetryEvent(
        `Error while fetching address info from addresses api: ${JSON.stringify(
          error
        )}`
      );
      throw error;
    }
  }
}

export default AddressClient;
